import {
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "react-html-email";

const PayrollBulkPreview = ({
  excelDbColMapping,
  editedRecord,
  setEditedRecord,
  earningTempSelected,
  selecttemp,
}) => {
  const Contractual =
  selecttemp === "Contractual Template" || 
  selecttemp === "Contractual Template : Daily Fixed";
  return (
    <>
      <form>
        <Grid
          container
          spacing={2}
          sx={{ pointerEvents: "none", opacity: 0.9 }}
        >
          {excelDbColMapping
            ?.filter((field) =>
              [
                "previous_employee_id",
                "ctc",
                "basic",
                "hra",
                "variable_percentage",
                "conveyance_allowance",
                "educational_allowance",
                "medical_allowance",
                "lta",
                "esic",
                "pt",
                "statutory_bonus_flag", 
                "gratuity_flag", 
                "pf_compliant_flag"
              ].includes(field.db)
            )
            ?.map((field) => {
              if (!editedRecord?.hasOwnProperty(field.db)) return null;
              return (
                <Grid item xs={12} key={field.db}>
                  <FormControl fullWidth>
                    {[
                      "previous_employee_id",
                      "ctc",
                      "basic",
                      "hra",
                      "variable_percentage",
                      "conveyance_allowance",
                      "educational_allowance",
                      "medical_allowance",
                      "lta",
                    ].includes(field.db) && (
                      <Typography variant="subtitle2" gutterBottom>
                        {field.label}
                      </Typography>
                    )}
                    {["esic", "pt", "statutory_bonus_flag", "gratuity_flag", "pf_compliant_flag"].includes(field.db) ? (
                      <FormControlLabel
                        label={field.label}
                        control={
                          <Checkbox
                            checked={!!editedRecord[field.db]} // Ensure boolean value
                            onChange={(e) => {
                              setEditedRecord((prev) => ({
                                ...prev,
                                [field.db]: e.target.checked,
                              }));
                            }}
                          />
                        }
                      />
                    ) : (
                      <TextField
                        size="small"
                        type={
                          ["previous_employee_id"].includes(field.db)
                            ? "text"
                            : "number"
                        }
                        variant="standard"
                        value={editedRecord[field.db] ?? ""}
                        onChange={(e) => {
                          let value = e.target.value;
                          const isNumberField = ![
                            "previous_employee_id",
                          ].includes(field.db);
                          if (isNumberField) {
                            const isValid = /^(\d+)?([.]?\d{0,2})?$/.test(
                              value
                            );
                            if (!isValid) return;

                            const parts = value.split(".");
                            if (parts.length > 1) {
                              value = `${parts[0]}.${parts[1].slice(0, 2)}`;
                            }
                          }
                          setEditedRecord((prev) => ({
                            ...prev,
                            [field.db]: value,
                          }));
                        }}
                        placeholder={`${field.label}`}
                      />
                    )}
                  </FormControl>
                </Grid>
              );
            })}
          <Grid
            container
            xs={12}
            md={12}
            p={"15px"}
          >
              <Grid container spacing={2} sx={{ pointerEvents: "none", opacity: 0.9 }}>
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    paddingRight: "7px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  PF
                  <div>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            //   onChange={() => handleToggle1("pf")}
                            checked={editedRecord?.pf}
                          />
                        }
                      />
                    </FormGroup>
                  </div>
                </Grid>
                {editedRecord?.pf && (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                      paddingRight: "7px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    EPS
                    <div>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              //   onChange={() => handleToggle1("pf")}
                              checked={editedRecord?.eps_applicable_flag}
                            />
                          }
                        />
                      </FormGroup>
                    </div>
                  </Grid>
                )}
              </Grid>
              {editedRecord?.pf && (
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                      marginTop: "1rem",
                      paddingLeft: "15px",
                      paddingRight: "7px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    Set PF Limit
                    <div>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              //   onChange={() => handleToggle1("pf_limit_applicable")}
                              checked={editedRecord?.pf_limit_applicable}
                            />
                          }
                        />
                      </FormGroup>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                      marginTop: "1rem",
                      px: "15px",
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    {editedRecord?.pf && editedRecord?.pf_limit_applicable && (
                      <FormControl fullWidth>
                        <TextField
                          size="small"
                          type="number"
                          required
                          value={editedRecord?.pf_limit_amount}
                          //   onChange={handleInputTemplate}
                          variant={"standard"}
                          fullWidth
                          id="pf_limit_amount"
                          label="PF Amount"
                          name="pf_limit_amount"
                          autoComplete="pf_limit_amount"
                        />
                      </FormControl>
                    )}
                  </Grid>
                </Grid>
              )}
          </Grid>
          {earningTempSelected &&
          <>
            {Array.isArray(editedRecord?.earning_component_json) && (
                <Grid item xs={12}>
                    <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        Earnings
                    </Typography>
                    <Grid container spacing={2}>
                        {editedRecord?.earning_component_json?.map((earning, index) => (
                        <Grid item xs={12}key={`earning-${index}`}>
                            <TextField
                                label={earning.label}
                                value={earning.value || ""}
                                //   onChange={(e) => {
                                //     const updatedValue = e.target.value;
                                //     setEditedRecord((prev) => {
                                //       const updatedEarnings = [...prev.earning_component_json];
                                //       updatedEarnings[index] = {
                                //         ...updatedEarnings[index],
                                //         value: updatedValue,
                                //       };
                                //       return {
                                //         ...prev,
                                //         earning_component_json: updatedEarnings,
                                //       };
                                //     });
                                //   }}
                                fullWidth
                                variant="standard"
                                type="number"
                                />
                        </Grid>
                        ))}
                    </Grid>
                    </Box>
                </Grid>
            )}
            {Array.isArray(editedRecord?.deduction_component_json) && (
                <Grid item xs={12}>
                    <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        Deductions
                    </Typography>
                    <Grid container spacing={2}>
                        {editedRecord?.deduction_component_json?.map((deduction, index) => (
                        <Grid item xs={12} key={`deduction-${index}`}>
                            <TextField
                                label={deduction.label}
                                value={deduction.value || ""}
                                //   onChange={(e) => {
                                //     const updatedValue = e.target.value;
                                //     setEditedRecord((prev) => {
                                //       const updatedEarnings = [...prev.earning_component_json];
                                //       updatedEarnings[index] = {
                                //         ...updatedEarnings[index],
                                //         value: updatedValue,
                                //       };
                                //       return {
                                //         ...prev,
                                //         earning_component_json: updatedEarnings,
                                //       };
                                //     });
                                //   }}
                                fullWidth
                                variant="standard"
                                type="number"
                            />
                        </Grid>
                        ))}
                    </Grid>
                    </Box>
                </Grid>
            )}
          </>
            }

            <Grid
              container
              xs={12}
              mt="1rem"
              sx={{ pointerEvents: "none", opacity: 0.9 }}
            >
            <Grid xs={12} sm={6} md={6} pl={"15px"}>
                <FormControlLabel
                    control={
                    <Checkbox
                        name="overtime_applicable_flag"
                        checked={
                        editedRecord?.overtime_applicable_flag || false
                        }
                        // onChange={handleInputChange1}
                    />
                    }
                    label={<span>Overtime</span>}
                />
                </Grid>
                <Grid xs={12} sm={6} md={6} pl={"15px"}>
                    <TextField
                        label={"Overtime Code"}
                        value={editedRecord?.overtime_code || ""}
                        //   onChange={(e) => {
                        //     const updatedValue = e.target.value;
                        //     setEditedRecord((prev) => {
                        //       const updatedEarnings = [...prev.earning_component_json];
                        //       updatedEarnings[index] = {
                        //         ...updatedEarnings[index],
                        //         value: updatedValue,
                        //       };
                        //       return {
                        //         ...prev,
                        //         earning_component_json: updatedEarnings,
                        //       };
                        //     });
                        //   }}
                        fullWidth
                        variant="standard"
                        type="text"
                        />

                </Grid>
              {Contractual && (
                <>
                  <Grid xs={12} sm={6} md={6} pl={"15px"}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="leave_wages_applicable"
                          checked={
                            editedRecord?.leave_wages_applicable || false
                          }
                          // onChange={handleInputChange1}
                        />
                      }
                      label={<span>Leave Wages</span>}
                    />
                  </Grid>
                  <Grid xs={12} sm={6} md={6} pl={"15px"}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="ph_wages_applicable"
                          checked={editedRecord?.ph_wages_applicable || false}
                          // onChange={handleInputChange1}
                        />
                      }
                      label={<span>Public Holiday Wages</span>}
                    />
                  </Grid>{" "}
                </>
              )}
              <Grid container spacing={2} pl={2}>
                 {/* // transport */}
                <Grid item xs={12} sm={6} md={6}>
                  <Box
                    sx={{
                      width: "90%",
                      margin: "auto",
                      padding: "0px 15px",
                      borderRadius: "8px",
                      background: editedRecord?.transport_applicable
                        ? "#f4f2f7"
                        : "none",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="transport_applicable"
                          checked={
                            editedRecord?.transport_allowance_applicable ||
                            false
                          }
                          // onChange={handleInputChange1}
                        />
                      }
                      label={<span>Transport Allowance</span>}
                    />

                    {editedRecord?.transport_allowance_applicable && (
                      <Box ml={"4px"}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                            {" "}
                            Allowance As
                          </FormLabel>
                          <RadioGroup
                            row
                            name="transport_type"
                            value={
                              editedRecord?.transport_earning_applicable
                                ? "earning"
                                : editedRecord?.transport_deduction_applicable
                                ? "deduction"
                                : ""
                            }
                            // onChange={handleInputChange1}
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              ml: "5px",
                            }} // Ensures flex row
                          >
                            <FormControlLabel
                              value="earning"
                              control={
                                <Radio
                                  size="small"
                                  sx={{ p: 0.5, mr: 0.5 }}
                                  checked={
                                    !!editedRecord?.transport_earning_applicable
                                  }
                                />
                              }
                              label={
                                <span style={{ fontSize: "0.95rem" }}>
                                  Earning
                                </span>
                              }
                              sx={{ mr: 2, minWidth: 0 }}
                            />
                            <FormControlLabel
                              value="deduction"
                              control={
                                <Radio
                                  size="small"
                                  sx={{ p: 0.5, mr: 0.5 }}
                                  checked={
                                    !!editedRecord?.transport_deduction_applicable
                                  }
                                />
                              }
                              label={
                                <span style={{ fontSize: "0.95rem" }}>
                                  Deduction
                                </span>
                              }
                              sx={{ minWidth: 0 }}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    )}
                  </Box>
                </Grid>
                {/* // food */}
                <Grid item xs={12} sm={6} md={6}>
                  <Box
                    sx={{
                      width: "90%",
                      padding: "0px 15px",
                      borderRadius: "8px",
                      background: editedRecord?.food_applicable
                        ? "#f4f2f7"
                        : "none",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="food_applicable"
                          checked={
                            editedRecord?.food_allowance_applicable || false
                          }
                          // onChange={handleInputChange1}
                        />
                      }
                      label={<span>Food Allowance</span>}
                    />

                    {editedRecord?.food_allowance_applicable && (
                      <Box ml={"4px"}>
                        <FormControl component="fieldset">
                          <FormLabel component="legend">
                            {" "}
                            Allowance As
                          </FormLabel>
                          <RadioGroup
                            row
                            name="food_type"
                            value={
                              editedRecord?.food_earning_applicable
                                ? "earning"
                                : editedRecord?.food_deduction_applicable
                                ? "deduction"
                                : ""
                            }
                            // onChange={handleInputChange1}
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              ml: "5px",
                            }} // Ensures flex row
                          >
                            <FormControlLabel
                              value="earning"
                              control={
                                <Radio
                                  size="small"
                                  sx={{ p: 0.5, mr: 0.5 }}
                                  checked={
                                    !!editedRecord?.food_earning_applicable
                                  }
                                />
                              }
                              label={
                                <span style={{ fontSize: "0.95rem" }}>
                                  Earning
                                </span>
                              }
                              sx={{ mr: 2, minWidth: 0 }}
                            />
                            <FormControlLabel
                              value="deduction"
                              control={
                                <Radio
                                  size="small"
                                  sx={{ p: 0.5, mr: 0.5 }}
                                  checked={
                                    !!editedRecord?.food_deduction_applicable
                                  }
                                />
                              }
                              label={
                                <span style={{ fontSize: "0.95rem" }}>
                                  Deduction
                                </span>
                              }
                              sx={{ minWidth: 0 }}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    )}
                  </Box>
                </Grid>
                {/* Include Paid week offs */}
                <Grid item xs={12} sm={6} md={6} pl={"15px"}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={editedRecord.week_off_caln_applicable}
                          // onChange={handleInputChange1}
                          name="week_off_caln_applicable"
                        />
                      }
                      label={<span>Include Paid Week Offs</span>}
                    />
                  </FormGroup>
                </Grid>
                      {/* Monthly Working hrs calc */}
                <Grid item xs={12} sm={6} md={6} pl={"15px"}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={editedRecord.working_hrs_monthly_caln}
                          // onChange={handleInputChange1}
                          name="working_hrs_monthly_caln"
                        />
                      }
                      label={<span>Monthly Working Hrs Cal.</span>}
                    />
                  </FormGroup>
                </Grid>
              </Grid>
            </Grid>
         
        </Grid>
        {/* <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            <Button
                variant="outlined"
                onClick={() => setOpenPopup(false)}
                className="mpl-secondary-btn"
            >
                Cancel
            </Button>
            <Button
                variant="contained"
                onClick={() => handleEditSubmit(editedRecord)}
                className="mpl-primary-btn"
            >
                Save
            </Button>
        </Box> */}
      </form>
    </>
  );
};

export default PayrollBulkPreview;
